import ReportTemplatesContainer from "./ReportTemplatesContainer";
export default ReportTemplatesContainer;
